<template lang="html">
  <div class="dashboard-background-container flex-box">
    <FullScreenSpinner v-if="fetchingUser" />
    <div
      class="center-container sign-up-container modal-scroll-bar"
    >
      <AuthHeader title="Create Account" v-if="!passwordOnly" />
      <AuthHeader title="Reset your Password" v-else />

      <div class="gap-3x" v-if="!passwordOnly" />
      <div class="description" v-if="!passwordOnly">
        Get started with your free account. Modify parcel information, save your
        edits, and stary informed with whats possible.
      </div>
      <div class="gap-3x" />

      <div class="sign-up-modal flex-box horizontally-centered wrap">
        <div class="sign-up-main">
          <div v-if="!passwordOnly">
            <div class="name-group">
              <SymbiumFormGroup
                label="First Name"
                v-bind:value.sync="firstname"
                :error="errors['firstname']"
                inputSize="sign-up-double-input-size"
              />
              <div class="gap-3x" />
              <SymbiumFormGroup
                label="Last Name"
                v-bind:value.sync="lastname"
                :error="errors['lastname']"
                inputSize="sign-up-double-input-size"
              />
            </div>
            <div class="gap-3x" />
            <SymbiumFormGroup
              label="Phone"
              v-bind:value.sync="phone"
              :error="errors['phone']"
              inputSize="sign-up-component-size"
            />
            <div class="gap-3x" />
            <SymbiumFormGroup
              label="Email"
              v-bind:value.sync="email"
              :error="errors['email']"
              :locked="true"
              inputSize="sign-up-component-size"
            />
            <div class="gap-3x" />
          </div>
          <SymbiumPasswordForm
            v-bind:password.sync="password"
            v-bind:passwordConfirmation.sync="passwordConfirmation"
            @password-validate="value => (this.validPassword = value)"
            inputSize="sign-up-component-size"
          />

          <div v-if="!passwordOnly">
            <div class="gap-3x" />
            <SymbiumAccountTerms
              :option="{ selected: termsAcceptance }"
              @toggle-option="termsAcceptance = !termsAcceptance"
            />
            <div class="gap-1x" />
            <SymbiumSelectableOption
              :option="{
                text: 'Subscribe to email updates',
                selected: subscribed,
              }"
              klass="email-subscribe"
              @toggle-option="subscribed = !subscribed"
            />
          </div>
        </div>
        <div class="gap-2x max-size" />
        <SymbiumModalFooter
          :mainAction="saveData"
          :silentAction="() => {}"
          mainActionText="Save"
          silentActionTitle=""
          silentActionText=""
          :mainActionLoading="loading"
          buttonSize="sign-up-component-size"
          :isDisabled="!passwordOnly && !termsAcceptance"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import LoadUser from 'src/mixins/LoadUser.js'
import HasSubscribedOption from 'src/mixins/HasSubscribedOption.js'
import DataValidation from 'src/mixins/DataValidation.js'

import FullScreenSpinner from 'src/components/common/FullScreenSpinner.vue'
import AuthHeader from 'src/components/authentication/shares/AuthHeader.vue'
import SymbiumAccountTerms from 'src/components/common/SymbiumAccountTerms.vue'
import SymbiumSelectableOption from 'src/components/common/form/SymbiumSelectableOption.vue'
import SymbiumPasswordForm from 'src/components/common/form/SymbiumPasswordForm.vue'
import SymbiumModalFooter from 'src/components/common/modals/shares/SymbiumModalFooter.vue'
import SymbiumFormGroup from 'src/components/common/form/SymbiumFormGroup.vue'

export default {
  components: {
    SymbiumModalFooter,
    SymbiumAccountTerms,
    SymbiumSelectableOption,
    FullScreenSpinner,
    AuthHeader,
    SymbiumPasswordForm,
    SymbiumFormGroup,
  },
  props: ['signupAction', 'afterSignIn', 'givenMessage'],
  mixins: [LoadUser, HasSubscribedOption, DataValidation],
  methods: {
    saveData() {
      if (!this.passwordOnly && !this.termsAcceptance) return
      if (!this.validate()) return
      if (this.loading) return
      this.loading = true
      this.$user.registerOnboarding(
        this.$data,
        this.afterOnboarding,
        this.errorHanlder
      )
    },
    afterOnboarding() {
      if (this.redirectURL) {
        window.location = this.redirectURL
      } else {
        this.$router.push('/dashboard')
      }
    },
    errorHanlder(error) {
      setTimeout(() => {
        var data = error.response.data
        this.errors = _.pickBy(data.errors, value => {
          return value
        })
        this.loading = false
      }, 250)
    },
    validate() {
      this.validateRequireField({ attribute: 'firstname' })
      this.validateRequireField({ attribute: 'lastname' })
      this.validateRequireField({ attribute: 'phone' })
      this.$nextTick(() => {
        this.$forceUpdate()
      })
      
      if(this.passwordOnly) return this.validPassword
      return _.values(this.errors).every(_.isNull) && this.validPassword
    },
    assignData(user) {
      var attributes = ['firstname', 'lastname', 'phone', 'email']
      Object.assign(this.$data, _.pick(user.data, attributes))
      this.fetchingUser = false
    },
    onInputChange(attribute, value) {
      this[attribute] = value
    },
  },
  watch: {
    firstname() {
      this.validateRequireField({ attribute: 'firstname' })
    },
    lastname() {
      this.validateRequireField({ attribute: 'lastname' })
    },
    phone() {
      this.validateRequireField({ attribute: 'phone' })
    },
  },
  data() {
    return {
      firstname: null,
      lastname: null,
      phone: null,
      email: null,
      password: null,
      passwordConfirmation: null,
      loading: false,
      fetchingUser: false,
      activation: this.$route.query.activation,
      errors: {},
      dirty: false,
      redirectURL: null,
      validPassword: false,
      passwordOnly: false,
      termsAcceptance: false,
    }
  },
  mounted() {
    var email = this.$route.query.email
    var activation = this.$route.query.activation
    this.redirectURL = this.$route.query.redirect_url
    this.passwordOnly = this.$route.query.password_only == 'true'
    this.fetchingUser = true
    this.$user.onboarding(email, activation, this.assignData)
  },
}
</script>

<style lang="scss">
</style>
